<template>
  <t-block-allow-ip />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TBlockAllowIp from "@/views/Common/TBlockAllowIP";

export default {
  name: "Ips",
  components: {
    TBlockAllowIp,
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("modal", ["openModal", "closeModal"]),
  },
  mounted() {
    this.setPageTitle(this.$t("Allow & Block List"));
    this.setPageSubtitle([]);
  },
};
</script>
